const Access = {
	Owner: 0,
	Manager: 10,
	Supervisor: 20,
	Employee: 30,
	Everyone: 100,
};

export default Access;